import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import * as woothee from "woothee";
var DEFAULT_USER_AGENT = "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/66.0.3359.181 Safari/537.36";
var ANDROID_MOBILE = /Android.+Mobi(le)?/;
export var UA = /*#__PURE__*/function () {
  function UA(ua) {
    _classCallCheck(this, UA);
    this._ua = ua;
    this._parsed = woothee.parse(ua);
  }
  return _createClass(UA, [{
    key: "original",
    value: function original() {
      return this._ua;
    }
  }, {
    key: "deviceType",
    value: function deviceType() {
      return this._parsed.category;
    }
  }, {
    key: "os",
    value: function os() {
      return this._parsed.os;
    }
  }, {
    key: "osVersion",
    value: function osVersion() {
      return this._parsed.os_version;
    }
  }, {
    key: "browser",
    value: function browser() {
      return this._parsed.name;
    }
  }, {
    key: "browserVersion",
    value: function browserVersion() {
      return this._parsed.version;
    }
  }, {
    key: "browserVendor",
    value: function browserVendor() {
      return this._parsed.vendor;
    }
  }, {
    key: "isFromIphone",
    value: function isFromIphone() {
      return this.os() === "iPhone";
    }
  }, {
    key: "isFromIpad",
    value: function isFromIpad() {
      return this.os() === "iPad";
    }
  }, {
    key: "isFromIpod",
    value: function isFromIpod() {
      return this.os() === "iPod";
    }
  }, {
    key: "isFromIos",
    value: function isFromIos() {
      return this.isFromIphone() || this.isFromIpad() || this.isFromIpod() || this.os() == "iOS";
    }
  }, {
    key: "isFromAndroidMobile",
    value: function isFromAndroidMobile() {
      return this.os() === "Android" && ANDROID_MOBILE.test(this._ua);
    }
  }, {
    key: "isFromAndroidTablet",
    value: function isFromAndroidTablet() {
      return this.os() === "Android" && !ANDROID_MOBILE.test(this._ua);
    }
  }, {
    key: "isFromAndroidOs",
    value: function isFromAndroidOs() {
      return this.isFromAndroidMobile() || this.isFromAndroidTablet() || this.os() == "Android";
    }
  }, {
    key: "isFromWindowsPhone",
    value: function isFromWindowsPhone() {
      return this.os() === "Windows Phone OS";
    }
  }, {
    key: "isFromPc",
    value: function isFromPc() {
      return this.deviceType() === "pc";
    }
  }, {
    key: "isFromSmartphone",
    value: function isFromSmartphone() {
      return this.deviceType() === "smartphone" && !this.isFromTablet();
    }
  }, {
    key: "isFromMobilephone",
    value: function isFromMobilephone() {
      return this.deviceType() === "mobilephone";
    }
  }, {
    key: "isFromAppliance",
    value: function isFromAppliance() {
      return this.deviceType() === "appliance";
    }
  }, {
    key: "isFromCrawler",
    value: function isFromCrawler() {
      return this.deviceType() === "crawler";
    }
  }, {
    key: "isFromTablet",
    value: function isFromTablet() {
      return this.isFromIpad() || this.isFromAndroidTablet();
    }
  }]);
}();
export default (function (ctx, inject) {
  var userAgent = DEFAULT_USER_AGENT;
  if (typeof ctx.req !== "undefined") {
    userAgent = ctx.req.headers["user-agent"]; // FIXME: Better case handling - 20181125 Shin Ando
  } else if (typeof navigator !== "undefined") {
    userAgent = navigator.userAgent;
  }
  ctx.$ua = new UA(userAgent);
  inject("ua", new UA(userAgent));
});